import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { EnvironmentService } from './environment.service';
/**
 * Get the News entries
 */
@Injectable({
  providedIn: 'root'
})
export class NewsService {
/**
 * constructor
 * @param http 
 * @param environment 
 */
  constructor(
    private http: HttpClient, 
    private environment: EnvironmentService) {

  }
/**
 * Get all News Paginated
 * @param page 
 * @param size 
 * @returns 
 */
  getNews(page, size): Observable<any> {
    const params = new HttpParams({
      fromObject: {
        page: page,
        size: size
      }
    })
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.post(`${url}/news`, { params })
      )
    )
  }
/**
 * Search for all News via the Filter
 * @param page 
 * @param size 
 * @param searchTerm 
 * @param filterByStates 
 * @param filterByTypes 
 * @param filterByVisibility 
 * @returns 
 */
  searchForNews(page, size, searchTerm, filterByStates, filterByTypes, filterByVisibility) {
    const params = new HttpParams({
      fromObject: {
        page: page,
        size: size
      }
    })
    const body = {
      searchTerm: searchTerm,
      filterByStates: (  filterByStates == undefined || filterByStates[0] == "") ? [] : filterByStates,
      filterByTypes: (filterByTypes == undefined || filterByTypes[0] == ""  )? null : filterByTypes,
      filterByVisibility: (filterByVisibility == undefined  || filterByVisibility[0] == "") ? [] : filterByVisibility
    }
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.post(`${url}/news/search`, body, { params })
      )
    )
  }
/**
 * Create a new News Object
 * @param news 
 * @returns 
 */
  createNews(news) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.post(`${url}/news`, news)
      )
    )
  }
/**
 * edit a news Entry
 * @param news 
 * @returns 
 */
  editNews(news) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.put(`${url}/news/${news.publicId}`, news)
      )
    )
  }
/**
 * Delete a news Entry
 * @param news 
 * @returns 
 */
  deleteNews(news) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.delete(`${url}/news/${news.publicId}`)
      )
    )
  }
/**
 * get a news Entry via the ID
 * @param NewsID 
 * @returns 
 */
  getOneNews(NewsID) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.delete(`${url}/news/${NewsID}`)
      )
    )
  }
}
